(() => {
  const pending = new Map();
  const merge = (catalog, live, format = 250) => {
    const unitPrice = format === 250 ? 1500 : format === 500 ? 2900 : null;
    if (!unitPrice || live?.schema !== 1 || live?.registered !== true || !Array.isArray(live.bottles)) throw new Error('catalog');
    const ids = new Set();
    for (const b of live.bottles) {
      if (!/^\d+$/.test(b.id) || ids.has(b.id) || b.format !== format || b.unitPrice !== unitPrice || typeof b.handle !== 'string' || !b.handle || typeof b.label !== 'string' || !Number.isFinite(b.stockSnapshot)) throw new Error('catalog');
      ids.add(b.id);
    }
    return {...catalog, bottles: [...catalog.bottles.filter(b => b.format !== format), ...live.bottles].sort((a, b) => a.label.localeCompare(b.label, 'fr'))};
  };
  const load = async (assetUrl, options = {}) => {
    const rootUrl = (options.rootUrl || '/').replace(/\/?$/, '/');
    const key = [assetUrl, rootUrl, options.previewThemeId || ''].join('|');
    if (!pending.has(key)) pending.set(key, (async () => {
      const base = await fetch(assetUrl, {credentials: 'same-origin'});
      if (!base.ok) throw new Error('catalog');
      const catalog = await base.json();
      const formats = [250, 500];
      const lists = await Promise.all(formats.map(async format => {
      const path = catalog['automatic' + format + 'Path'];
      if (!path) return null;
      const url = new URL(rootUrl + path, location.origin);
      url.searchParams.set('_lm', String(Date.now()));
      if (options.previewThemeId) url.searchParams.set('preview_theme_id', options.previewThemeId);
      const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'text/html'}});
      if (!response.ok) throw new Error('catalog');
      return response.json();
      }));
      return lists.reduce((merged, live, i) => live ? merge(merged, live, formats[i]) : merged, catalog);
    })());
    try {return structuredClone(await pending.get(key));}
    catch (error) {pending.delete(key);throw error;}
  };
  window.LeManuscrisCoffretCatalog = {load, merge};
})();
